import React from 'react';
import { ShieldCheck, Zap, Lock } from 'lucide-react';
import { goToCheckout } from '../constants/links';
export function FinalCTA() {
  return <section className="bg-violet text-white py-12" data-id="element-52">
      <div className="max-w-md mx-auto px-4 text-center" data-id="element-53">
        <h2 className="text-[28px] font-extrabold leading-tight mb-8" data-id="element-54">
          Tu próximo acto escolar ya puede estar resuelto. 🎵
        </h2>

        <div className="flex flex-col gap-3 mb-8" data-id="element-55">
          <button onClick={() => goToCheckout('base')} className="w-full h-[56px] bg-turquoise hover:bg-turquoise/90 text-white font-bold text-lg rounded-xl transition-colors shadow-lg shadow-turquoise/20" data-id="element-56">
            🎵 Quiero Flauta Master Class
          </button>
          <button onClick={() => goToCheckout('pro')} className="w-full h-[56px] bg-transparent border-2 border-white text-white font-bold text-lg rounded-xl transition-colors hover:bg-white/10" data-id="element-57">
            🚀 Quiero el Plan PRO
          </button>
        </div>

        <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs font-medium text-white/90" data-id="element-58">
          <div className="flex items-center gap-1" data-id="element-59">
            <ShieldCheck className="w-3.5 h-3.5" data-id="element-60" />
            <span data-id="element-61">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-1" data-id="element-62">
            <Lock className="w-3.5 h-3.5" data-id="element-63" />
            <span data-id="element-64">Pago seguro</span>
          </div>
          <div className="flex items-center gap-1" data-id="element-65">
            <Zap className="w-3.5 h-3.5" data-id="element-66" />
            <span data-id="element-67">Acceso inmediato</span>
          </div>
        </div>
      </div>
    </section>;
}